/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MedbookHistoryChangeChangesInner } from './medbookHistoryChangeChangesInner';


/**
 * 
 */
export interface MedbookHistoryChange { 
    /**
     * 
     */
    value?: object;
    /**
     * 
     */
    before?: object;
    /**
     * 
     */
    after?: string;
    /**
     * 
     */
    field: string;
    /**
     * 
     */
    type: MedbookHistoryChange.TypeEnum;
    /**
     * 
     */
    isDelete?: boolean;
    /**
     * 
     */
    isCreate?: boolean;
    /**
     * 
     */
    changes?: Array<MedbookHistoryChangeChangesInner>;
}
export namespace MedbookHistoryChange {
    export type TypeEnum = 'tags' | 'changes' | 'text' | 'context';
    export const TypeEnum = {
        Tags: 'tags' as TypeEnum,
        Changes: 'changes' as TypeEnum,
        Text: 'text' as TypeEnum,
        Context: 'context' as TypeEnum
    };
}


